import { ArrowLeftOutlined, CaretDownOutlined, CopyOutlined, DeleteOutlined, DownOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Form, Input, Mentions, message, Select } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../Layout';
import useToast from '../../hook/useToast';
import { buildOptionsV2, convertStringToHTML, fommatSelectOption } from '../../until';
import './NotificationDetail.scss';
import useDebounce from '../../hook/useDebounce';
import { getSlListCustomerFieldsV2, getSLParameters, getSLSmsProvider, getSLTemplate, ISelectOption, ISelectOptionMentions, ISLCustomerFields } from '../../api/selectOptions/selectOptionsApi';
import { addNotificationTemplate, getInfoTemplate, getListBrandConfigs, IBrandConfigs } from '../../api/notificationTemplate/notificationTemplateApi';
import useLoading from '../../hook/useLoading';
import useThrottle from '../../hook/useThrottle';
import { CHANNELTYPE } from '../../services/data';

export const formatSelectOptionMentions = (
  data: { id: number; title: string }[]
): ISelectOptionMentions[] => {
  return data.map(item => ({
    value: String(item.id),
    label: item.title
  }))
}

const NotificationSMSCreate: React.FC = () => {
  useEffect(() => {
    gSLProvider()
    gSLParameters()
    gSlListCustomerFieldsV2()
  }, []);

  const [form] = useForm()
  const pushToast = useToast();
  const navigate = useNavigate()
  const pushLoading = useLoading()
  const location = useLocation();

  const { type: typeState } = location?.state ?? {}

  const providerId = Form.useWatch("providerId", form);
  const brandNameIds = Form.useWatch("brandNameIds", form) || []
  // const templateId = Form.useWatch("templateId", form)
  const content = Form.useWatch("content", form) ?? ""
  const selectedIds = useMemo(
    () => brandNameIds.map((i: any) => i?.brandName).filter(Boolean),
    [brandNameIds]
  );

  const [sLTemplate, setSLTemplate] = useState<ISLCustomerFields[]>([])
  const [searchText, setSearchText] = useState('');


  const [openMap, setOpenMap] = useState<boolean>();
  const [expandMap, setExpandMap] = useState<string[]>([]);
  const [searchTemplate, setSearchTemplate] = useState<string>('')
  const [selectValue, setSelectValue] = useState<number | undefined>(undefined)

  const [openCollapse, setOpenCollapse] = useState<boolean>(true)

  const [sLProvider, setSLProvider] = useState<ISelectOption[]>([])
  const [sLParameters, setSLParameters] = useState<ISelectOptionMentions[]>([])

  const [listBrandConfigs, setListBrandConfigs] = useState<IBrandConfigs[]>([])

  const getOptions = (currentId?: number) => {
    return listBrandConfigs
      .filter(b => !selectedIds.includes(b.id) || b.id === currentId)
      .map(b => ({
        label: b.brandName,
        value: b.id
      }))
  }

  //#region  SL OP
  const gSLProvider = async () => {
    pushLoading(true)
    const result = await getSLSmsProvider()
    if (result?.status) {
      setSLProvider(fommatSelectOption(result.data))
    }
    pushLoading(false)
  }

  const gSLParameters = async () => {
    pushLoading(true)
    const result = await getSLParameters()
    if (result?.status) {
      setSLParameters(formatSelectOptionMentions(result.data))
    }
    pushLoading(false)
  }

  const gSlListCustomerFieldsV2 = useDebounce(async () => {
    pushLoading(true)
    const result = await getSlListCustomerFieldsV2(undefined, undefined, searchTemplate
    )
    if (result?.status) {
      setSLTemplate(result.data)
    }
    pushLoading(false)
  }, 1000)

  // hàm xử lý select trường V2
  const options = useMemo(() => buildOptionsV2(sLTemplate), [sLTemplate]);

  const selectableOptions = options.filter(
    (item) => !item.isGroup
  );
  // end





  const toggleGroup = (groupKey: string) => {
    setExpandMap((prev) =>
      prev.includes(groupKey)
        ? prev.filter((k) => k !== groupKey)
        : [...prev, groupKey]
    );
  };


  //#endregion

  const gListBrandConfigs = useDebounce(async () => {
    if (!providerId) {
      setListBrandConfigs([])
      return
    }

    pushLoading(true)
    const result = await getListBrandConfigs(providerId)
    if (result?.status) {
      setListBrandConfigs(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  // const gInfoTemplate = useDebounce(async () => {
  //   if (!templateId) {
  //     return
  //   }

  //   pushLoading(true)
  //   const result = await getInfoTemplate(templateId)
  //   if (result?.status) {
  //     form.setFieldValue("content", result.data.content)
  //   } else {
  //     pushToast(result?.message, "warning")
  //   }
  //   pushLoading(false)
  // }, 1000)

  const handleSelectBrand = (value: number, index: number) => {
    const brand = listBrandConfigs.find(b => b.id === value)

    if (!brand) return

    const current = form.getFieldValue("brandNameIds") || []

    current[index] = {
      ...current[index],
      brandName: value,
      messageType: brand.messageType,
      categoryCarIds: brand.categories
    }

    form.setFieldsValue({
      brandNameIds: current
    })
  }

  const onFinish = useThrottle(async (values: any) => {

    const { title, providerId, brandNameIds, content } = values ?? {}

    const brandNameIdsTmp = brandNameIds?.map((item: any) => item.brandName)
    pushLoading(true)
    const result = await addNotificationTemplate(
      title, content, CHANNELTYPE.SMS, brandNameIdsTmp,
      undefined, undefined, providerId
    )
    if (result.status) {
      pushToast(result.message, 'success', 2000)
      navigate('/marketing/notification-templates-management', {
        state: {
          type: typeState ?? CHANNELTYPE.SMS
        }
      })
    } else {
      pushToast(result.message, 'error', 2000)

    }
    pushLoading(false)
  }, 1000)

  useEffect(() => {
    if (!providerId) return;
    gListBrandConfigs(providerId)

    form.setFieldsValue({
      brandNameIds: [{
        brandName: undefined,
        messageType: undefined,
        categoryCarIds: undefined
      }]
    })
  }, [providerId])

  // useEffect(() => {
  //   gInfoTemplate()
  // }, [templateId])

  useEffect(() => {
    gSlListCustomerFieldsV2()
  }, [searchTemplate])

  return (
    <div className="notification-templates-management">
      <Layout>
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Marketing</a>,
            },
            {
              title: 'Quản lý mẫu thông báo',
            },
          ]}
        />

        <div className='title-page title-sub title-btn-back'>
          <div
            className="cursor-pointer"
            onClick={() => navigate(`/marketing/notification-templates-management`, { state: { type: typeState ?? CHANNELTYPE.SMS } })}
          >
            <ArrowLeftOutlined />
          </div>
          Tạo mẫu mới
          <div className="sub-title">Tạo nội dung mẫu SMS</div>
        </div>

        <div
          className='custom-page-css flex gap-6'
        >
          <div className="custom-page-css flex flex-col flex-3 gap-3">
            <Form
              className="custom-page-css flex flex-col flex-3 gap-3"
              initialValues={{
                remember: true,
                brandNameIds: [
                  {
                    brandName: undefined,
                  }
                ]
              }}
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
              form={form}
            >
              <div className="custom-page-css flex gap-6 justify-between">
                <Form.Item
                  className='custom-page-css w-full'
                  name="title"
                  rules={[{ required: true, message: 'Tên mẫu không được để trống!' }]}
                >
                  <Input
                    className="custom-input-css custom-page-css"
                    placeholder="Nhập tên mẫu, ví dụ: Mẫu chào sản phẩm mới" />
                </Form.Item>

                <Form.Item className='ctrl-w-btn'>
                  <Button className="custom-page-css flex items-center" type="primary" htmlType="submit">
                    <div className="icon-svg pt-1">
                      <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_10159_3402)">
                          <path d="M12.9581 3.98491L10.4174 1.44429C10.3002 1.3271 10.1565 1.24116 10.0002 1.19429V1.1521H1.25024C0.973682 1.1521 0.750244 1.37554 0.750244 1.6521V13.1521C0.750244 13.4287 0.973682 13.6521 1.25024 13.6521H12.7502C13.0268 13.6521 13.2502 13.4287 13.2502 13.1521V4.69116C13.2502 4.42554 13.1456 4.17241 12.9581 3.98491ZM5.00024 2.2771H9.00025V3.9021H5.00024V2.2771ZM12.1252 12.5271H1.87524V2.2771H4.00024V4.4021C4.00024 4.67866 4.22368 4.9021 4.50024 4.9021H9.50025C9.77681 4.9021 10.0002 4.67866 10.0002 4.4021V2.61772L12.1252 4.74272V12.5271ZM7.00025 6.30835C5.75806 6.30835 4.75024 7.31616 4.75024 8.55835C4.75024 9.80054 5.75806 10.8084 7.00025 10.8084C8.24243 10.8084 9.25025 9.80054 9.25025 8.55835C9.25025 7.31616 8.24243 6.30835 7.00025 6.30835ZM7.00025 9.80835C6.30962 9.80835 5.75024 9.24898 5.75024 8.55835C5.75024 7.86773 6.30962 7.30835 7.00025 7.30835C7.69087 7.30835 8.25025 7.86773 8.25025 8.55835C8.25025 9.24898 7.69087 9.80835 7.00025 9.80835Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_10159_3402">
                            <rect width="1em" height="1em" fill="white" transform="translate(0 0.400024)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="text">Lưu mẫu</div>
                  </Button>
                </Form.Item>
              </div>
              <div className="custom-page-css flex flex-col gap-3">
                <div className="custom-page-css text-base text-344054 font-medium">Cấu hình</div>
                <Form.Item
                  name='providerId'
                  className="m-none-form-item text-explan"
                  rules={[{ required: true, message: 'Cấu hình không được để trống!' }]}
                >
                  <Select
                    placeholder="Cấu hình"
                    className='custom-page-css border rounded overflow-hidden'
                    options={sLProvider}
                  />
                </Form.Item>
              </div>
              <div className="custom-page-css flex flex-col gap-3">
                <div className="custom-page-css flex items-center gap-3 text-base text-344054 font-medium cursor-pointer"
                  onClick={() => setOpenCollapse(!openCollapse)}
                >
                  Thiết lập brandname để gửi tin
                  <DownOutlined style={{ rotate: openCollapse ? '180deg' : '0deg' }} />
                </div>
                <div className={openCollapse ? 'block' : 'hidden'}>
                  <Form.List
                    name="brandNameIds"
                  >
                    {(fields, { add, remove }) => (
                      <div className={` custom-page-css flex flex-col gap-4`}
                      >
                        {fields.map(({ key, name, ...restField }, index) => (
                          <div
                            key={key}
                            className="custom-page-css grid grid-cols-1fr_1fr_1fr_auto gap-4 items-end"
                          >
                            <Form.Item
                              {...restField}
                              name={[name, "brandName"]}
                              label="Brandname"
                              rules={[{ required: true, message: "Chọn brandname" }]}
                            >
                              <Select
                                placeholder="Brandname"
                                className='custom-page-css border rounded overflow-hidden'
                                disabled={!providerId}
                                options={getOptions(
                                  form.getFieldValue(["brandNameIds", name, "brandName"])
                                )}
                                onChange={(value) => handleSelectBrand(value, name)}
                              />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "categoryCarIds"]}
                              label="Thương hiệu hãng xe"
                            >
                              <Input
                                placeholder="Thương hiệu hãng xe"
                                className='custom-page-css border rounded overflow-hidden'
                                disabled
                              />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "messageType"]}
                              label="Loại tin"
                            >
                              <Input
                                placeholder="Loại tin"
                                className='custom-page-css border rounded overflow-hidden'
                                disabled
                              />
                            </Form.Item>
                            <Button
                              danger
                              disabled={fields.length === 1}
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                            />
                          </div>
                        ))}
                        <Button
                          type="dashed"
                          icon={<PlusOutlined />}
                          onClick={() =>
                            add({
                              categoryCarIds: undefined,
                              brandName: undefined
                            })
                          }
                          className="w-fit"
                        >
                          Thêm brandname
                        </Button>
                      </div>
                    )}
                  </Form.List>
                </div>
              </div>
              <div className="d-flex justify-between align-center pb-4">
                <p className="text-base fw-700 font-bold text-344054 pb-4">Nội dung</p>
                <div className="w-250-px">
                  <Form.Item
                    name="variables"
                    className="m-none-form-item text-explan"
                  >
                    <Select
                      showSearch
                      onSearch={(value) => {
                        setSearchText(value);
                        setSearchTemplate(value);
                      }}
                      value={selectValue}
                      open={openMap}
                      onDropdownVisibleChange={(open) => {
                        setOpenMap(open);
                        if (!open) {
                          setSearchText('');
                          setSearchTemplate('')
                        }
                      }}
                      onChange={(value) => {
                        setSelectValue(value);
                      }}
                      placeholder="Tham số"
                      // style={{ width: 320 }}
                      optionFilterProp="label"
                      options={selectableOptions}
                      filterOption={false}

                      dropdownRender={() => (
                        <div
                          style={{
                            maxHeight: 350,
                            overflowY: "auto",
                          }}
                        >
                          {options.filter((item) => {
                            if (!searchText) return true;
                            const keyword = searchText.toLowerCase();
                            if (item.isGroup) {
                              // Giữ group nếu có child khớp
                              return options.some(
                                (o) => !o.isGroup && o.parentKey === item.key && o.label.toLowerCase().includes(keyword)
                              );
                            }
                            return item.label.toLowerCase().includes(keyword);
                          }).map((item) => {
                            if (item.isGroup) {


                              return (
                                <div
                                  key={item.key}
                                  onClick={() => toggleGroup(item.key)}
                                  style={{
                                    padding: "8px 12px",
                                    fontWeight: 600,
                                    background: "#fafafa",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                  }}
                                >
                                  <CaretDownOutlined
                                    rotate={expandMap.includes(item.key) ? 0 : -90}
                                  />
                                  {item.title}
                                </div>
                              );
                            }

                            const groupKey = item.parentKey;
                            if (groupKey && !expandMap.includes(groupKey)) {
                              return null;
                            }

                            return (
                              <div
                                key={item.key}
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                }}
                                // onClick={() => {
                                //     console.log(i, item)
                                //     setValue(item.value); // chọn value
                                //     handleChangeField(i, item);
                                //     setOpen(false);       // đóng dropdown
                                // }}
                                className="custom-page-css flex justify-between items-center gap-2 items-option"
                                onClick={() => {
                                  // handleChangeField(i, item);
                                  setSelectValue(item.value);

                                  form.setFieldValue("variables", item.value);

                                  setOpenMap(false);
                                }}
                                style={{
                                  padding: "8px 32px",
                                  cursor: "pointer",

                                }}
                              >
                                {item.label} {`{${item?.fieldCode}}`}
                                <CopyOutlined
                                  style={{
                                    color: '#096DD9'
                                  }}
                                  onClick={async (e) => {
                                    e.stopPropagation();

                                    const textToCopy = `{{${item.fieldCode}}}`;

                                    await navigator.clipboard.writeText(textToCopy);

                                    message.success("Đã copy");
                                  }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    />
                  </Form.Item>

                </div>

              </div>

              <Form.Item
                name="content"
                rules={[{ required: true, message: 'Nội dung không được để trống!' }]}
                className='t-mb-16'
              >
                <Mentions
                  rows={10}
                  options={sLParameters}
                />
              </Form.Item>
              <div className="custom-page-css flex justify-end note">
                <div className="text-block">
                  <span>Số lượng ký tự (</span>
                  <span className="cl-1890FF">{content.length ?? 0})</span>
                  {/* <span>) đang tính tiền với giá của</span>
                  <span className="cl-1890FF t-px-4">{smsCount}</span>
                  <span>tin nhắn SMS</span> */}
                </div>
                {/* <div className="icon-svg pl-1"><QuestionCircleOutlined /></div> */}
              </div>
            </Form>
          </div>

          <div className="right-new">
            <div className="t-title-16-bold t-mb-12">Xem trước mẫu gửi đi</div>
            <div className="inner-block">
              <div className="inner-mod">
                <div className="img-block">
                  <img src="/avatar-pr.svg" alt="" />
                  <div className="title">THACO AUTO</div>
                </div>
                <div className="t-px-24">
                  <div className="content-block">
                    {convertStringToHTML(content)}
                  </div>
                  {/* <div className="time">3:39PM</div> */}
                </div>
              </div>
            </div>

            <div className="btn-reset">
              <div className="btn">
                <div className="icon-svg"><ReloadOutlined /></div>
                <div className="text">Tải lại mẫu xem trước</div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
}

export default NotificationSMSCreate;
